import React from 'react'
import PropTypes from 'prop-types'
import cssModules from 'react-css-modules'
import styles from './modal.less'
import HeaderImage from 'components/common/header_image'

import {
  disableBodyScrollability,
  enableBodyScrollability,
  scrollToTop,
} from 'lib/scroll'

const ESC_KEY_CODE = 27

class Modal extends React.Component {
  static propTypes = {
    children: PropTypes.any.isRequired,
    styles: PropTypes.object,
    leftHeader: PropTypes.any,
    centerHeader: PropTypes.any,
    onClose: PropTypes.func,
    glimpse: PropTypes.bool,
    showSpinner: PropTypes.bool,
    showClose: PropTypes.bool,
    showIcon: PropTypes.bool,
    animate: PropTypes.bool,
    background: PropTypes.element,
    hideTopWithoutHeader: PropTypes.bool,
    showHeader: PropTypes.bool,
    headerImageSrc: PropTypes.string,
  }

  static defaultProps = {
    animate: true,
    showClose: true,
    showIcon: true,
    hideTopWithoutHeader: false,
    showHeader: false,
  }

  handleClose = () => {
    if (this.props.onClose) {
      this.props.onClose()
    }
  }

  scrollToTop = () => {
    scrollToTop(this.container)
  }

  onKeyUp = event => {
    if (event.keyCode === ESC_KEY_CODE || event.which === ESC_KEY_CODE) {
      this.handleClose()
    }
  }

  registerForEscKey = () => {
    window.addEventListener('keyup', this.onKeyUp)
  }

  unregisterForEscKey = () => {
    window.removeEventListener('keyup', this.onKeyUp)
  }

  componentDidMount() {
    this.registerForEscKey()
    if (this.props.glimpse) {
      disableBodyScrollability(this.container)
    }
  }

  componentWillUnmount() {
    this.unregisterForEscKey()
    if (this.props.glimpse) {
      enableBodyScrollability(this.container)
    }
  }

  render() {
    const Background = this.props.background

    let modalWrapperStyles = ['modal-wrapper']

    if (this.props.glimpse) {
      modalWrapperStyles.push('glimpse')
    }

    const hasTopPart = !!(
      this.props.leftHeader ||
      this.props.centerHeader ||
      this.props.showClose
    )

    return (
      <div
        styleName="modal-overflow-container"
        ref={container => {
          this.container = container
        }}
        tabIndex={1}
        aria-modal="true"
        role="dialog"
      >
        <div styleName={modalWrapperStyles.join(' ')}>
          <div
            styleName="white-part"
            className={this.props.showSpinner ? 'vx_has-spinner-large' : ''}
          >
            {(hasTopPart || !this.props.hideTopWithoutHeader) && (
              <div
                styleName={`modal-header ${
                  this.props.showHeader ? 'modal-header-with-image' : ''
                }`}
                data-autofocus-inside
              >
                {this.props.showHeader && (
                  <HeaderImage src={this.props.headerImageSrc} />
                )}
                <div styleName="left-header">{this.props.leftHeader}</div>
                <div styleName="center-header">{this.props.centerHeader}</div>
                {this.props.showClose && (
                  <span
                    data-pa-click="close"
                    className="icon icon-small icon-close-small"
                    styleName="x-button"
                    onClick={this.handleClose}
                    role="button"
                    tabIndex="0"
                  />
                )}
              </div>
            )}
            <div styleName="contents">
              {this.props.background && (
                <div styleName="modal-background">
                  <Background />
                </div>
              )}
              {this.props.children}
            </div>
            {this.props.showIcon && <div styleName="pp-icon" />}
          </div>
        </div>
      </div>
    )
  }
}

export default cssModules(Modal, styles, { allowMultiple: true })
